export default {
  // Default English translations
  welcome: "Welcome",
};





